import * as React from 'react';

import {Button} from 'shells/button/button';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function AdTechFXButton() {
    const {onOpen} = useOpenableModal(OpenableModals.ADTECH_FX_INTEREST_MODAL);

    return (
        <Button icon={AiSparkleNewIcon} variant='secondary' size='big' onClick={onOpen}>
            Advertise to these leads
        </Button>
    );
}
